import React from 'react'

const Footer = () => {
  return (
    <footer className='footer' style={{ zIndex: 1000 }}>
      <div className='content has-text-centered'>
        <a href="/" title="home">greetings.wallknown.com</a>. All rights reserved.
        <span className="px-2">|</span>
        <a href='mailto:greetings.wallknown@gmail.com' target='_blank' title='Email us'><span>Email us</span></a>
        </div>
    </footer>
  )
}

export default Footer
